module.exports = __webpack_public_path__ + "media/images/ControllerDark-48810ba1.jpg";